import { useQuery, UseQueryOptions } from 'react-query'

import { useCurrentSite } from '../../components/SitesProvider'
import request from '../../config/axios'
import QueryKeys from './QueryKeys'

export interface Note {
  id: string
  content: string
  notableId: string
  notableType: string
}

interface NoteResponse {
  note: Note
}

interface UseNoteParams {
  notableId?: string
  notableType?: string
}

const useNote = (
  { notableId, notableType }: UseNoteParams,
  extraOptions: UseQueryOptions<Note | null> = {},
) => {
  const siteId = useCurrentSite()?.id

  // Build a query key based on the provided polymorphic identifiers.
  const key =
    notableId && notableType
      ? QueryKeys.notes({ notableId, notableType })
      : ['notes', 'no-notable']

  // Build the URL to hit the index action with the required query parameters.
  const url = `/impacts/notes?notable_id=${notableId}&notable_type=${notableType}&site_ids[]=${siteId}`

  return useQuery<Note | null>(
    key,
    async () => {
      if (notableId && notableType) {
        const { data } = await request.get<NoteResponse>(url)
        return data.note
      }
      return null
    },
    {
      enabled: Boolean(notableId && notableType),
      ...extraOptions,
    },
  )
}

export default useNote
